// Auto-generated localized SEO meta for the homepage (22 markets). Natural, market-specific — not literal translations.
export const SEO_LANDING = {
  "fr": {
    "title": "Ma Petite Ferme – Logiciel élevage & ferme",
    "description": "Logiciel de gestion pour petites fermes et élevages : animaux, santé, productions, factures et boutique en ligne. Simple, en français — essai gratuit."
  },
  "en": {
    "title": "Ma Petite Ferme – Farm & Livestock Software",
    "description": "Farm management software for small farms & livestock: track animals, health, and sales invoices. Ma Petite Ferme — simple & efficient. Start your free trial!"
  },
  "es": {
    "title": "Ma Petite Ferme – Software para ganaderos",
    "description": "Software de gestión para pequeñas granjas y ganadería: animales, salud, producciones y facturación. Sencillo y eficaz con Ma Petite Ferme — prueba gratis."
  },
  "it": {
    "title": "Ma Petite Ferme – Software per allevatori",
    "description": "Software gestionale per piccole fattorie e allevamenti: animali, salute, produzioni e fatture. Semplice e intuitivo con Ma Petite Ferme — prova gratuita!"
  },
  "de": {
    "title": "Ma Petite Ferme – Software für Kleinbauern",
    "description": "Verwaltungssoftware für kleine Bauernhöfe: Tiere, Gesundheit, Produktion & Online-Shop einfach verwalten. Ma Petite Ferme – jetzt kostenlos testen!"
  },
  "nl": {
    "title": "Ma Petite Ferme – Software voor veehouders",
    "description": "Beheersoftware voor kleine boerderijen: dieren, gezondheid, producties en facturen. Ma Petite Ferme — eenvoudig en snel. Start je gratis proefperiode!"
  },
  "sv": {
    "title": "Ma Petite Ferme – Mjukvara för lantbrukare",
    "description": "Mjukvara för små gårdar och djurhållning: hantera djur, hälsa, produktion och fakturor enkelt med Ma Petite Ferme. Prova gratis idag!"
  },
  "da": {
    "title": "Ma Petite Ferme – Software til landmænd",
    "description": "Administrationssoftware til små landbrug og husdyrbrug: dyr, sundhed, produktion og fakturaer. Enkelt og effektivt – prøv Ma Petite Ferme gratis i dag!"
  },
  "bg": {
    "title": "Ma Petite Ferme – Софтуер за фермери",
    "description": "Софтуер за управление на малки ферми и животновъдство: животни, здраве, продукции и фактури. Ma Petite Ferme — просто и ефективно. Безплатен пробен период."
  },
  "el": {
    "title": "Ma Petite Ferme – Λογισμικό κτηνοτροφίας",
    "description": "Λογισμικό διαχείρισης για μικρές φάρμες και κτηνοτροφίες: ζώα, υγεία, παραγωγές και τιμολόγια. Απλό και αποτελεσματικό — δοκιμάστε το δωρεάν."
  },
  "hr": {
    "title": "Ma Petite Ferme – Softver za uzgajivače",
    "description": "Softver za upravljanje malim farmama: životinje, zdravlje, proizvodnja i fakture — Ma Petite Ferme. Jednostavno i učinkovito. Isprobajte besplatno!"
  },
  "et": {
    "title": "Ma Petite Ferme – Tarkvara väiketalunikele",
    "description": "Väiketalu haldustarkvara loomade, tervise ja toodangu haldamiseks — arved, veebipood ja lihtsad tööriistad. Ma Petite Ferme — proovi tasuta!"
  },
  "fi": {
    "title": "Ma Petite Ferme – Ohjelmisto pientiloille",
    "description": "Pienfarmien hallintaohjelmisto: eläimet, terveys, tuotanto ja verkkokauppa helposti. Ma Petite Ferme — kokeile ilmaiseksi!"
  },
  "hu": {
    "title": "Ma Petite Ferme – Szoftver kisgazdáknak",
    "description": "Kis gazdaságok kezelőszoftvere: állatok, egészség, termelés és online bolt egy helyen. Egyszerű és hatékony — Ma Petite Ferme — próbáld ki ingyen!"
  },
  "lv": {
    "title": "Ma Petite Ferme – Programma zemniekiem",
    "description": "Mazās fermas pārvaldības programmatūra: dzīvnieki, veselība, ražošana un rēķini. Vienkārša un ērta — Ma Petite Ferme. Izmēģini bez maksas!"
  },
  "lt": {
    "title": "Ma Petite Ferme – Programinė įranga ūkininkams",
    "description": "Ūkio valdymo programinė įranga mažiems ūkiams: gyvūnai, sveikata, produkcija ir sąskaitos. Ma Petite Ferme — paprasta ir efektyvu. Išbandykite nemokamai!"
  },
  "pl": {
    "title": "Ma Petite Ferme – Oprogramowanie dla rolników",
    "description": "Oprogramowanie do zarządzania małą fermą i hodowlą: zwierzęta, zdrowie, produkcja i faktury. Ma Petite Ferme — proste i skuteczne. Wypróbuj za darmo!"
  },
  "pt": {
    "title": "Ma Petite Ferme – Software para agricultores",
    "description": "Software de gestão para pequenas fazendas e criações: animais, saúde, produções e faturas. Ma Petite Ferme — simples e completo. Teste grátis!"
  },
  "ro": {
    "title": "Ma Petite Ferme – Software pentru fermieri",
    "description": "Software de gestiune pentru ferme mici și crescătorii: animale, sănătate, producții și facturi. Ma Petite Ferme — simplu și eficient. Încearcă gratuit!"
  },
  "sk": {
    "title": "Ma Petite Ferme – Softvér pre malých farmárov",
    "description": "Softvér na správu malých fariem a chovov: zvieratá, zdravie, produkcia a faktúry. Ma Petite Ferme – jednoduché riešenie. Vyskúšajte zadarmo!"
  },
  "sl": {
    "title": "Ma Petite Ferme – Programska oprema za kmete",
    "description": "Programska oprema za upravljanje malih kmetij: živali, zdravje, proizvodnja in računi. Preprosto in učinkovito z Ma Petite Ferme — brezplačno preizkusite!"
  },
  "cs": {
    "title": "Ma Petite Ferme – Software pro malé farmáře",
    "description": "Software pro správu malých farem a chovů: zvířata, zdraví, produkce a faktury. Jednoduché řešení Ma Petite Ferme — vyzkoušejte zdarma."
  }
};
